var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-form"},[_c('b-modal',{attrs:{"id":_vm.id,"size":_vm.size,"hide-footer":"","centered":""}},[_c('div',{staticClass:"col-12 d-flex flex-column align-items-center"},[_c('div',{staticClass:"title-modal font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._t("default")],2)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }